document.addEventListener('DOMContentLoaded', () => {
  const dateInput = document.querySelector('.js-delivery-date');
  const priorityCheckbox = document.getElementById('PriorityDelivery');

  if (!dateInput || typeof flatpickr === 'undefined') return;

  let picker;

  function initNormalMode() {
    if (picker) picker.destroy();

    picker = flatpickr(dateInput, {
      locale: 'ja',
      dateFormat: 'Y-m-d',
      disableMobile: true,

      // 2日後以降
      minDate: new Date().fp_incr(2),

      // 木曜不可
      disable: [
        function (date) {
          return date.getDay() === 4;
        }
      ]
    });
  }

  function initPriorityMode() {
    if (picker) picker.destroy();

    picker = flatpickr(dateInput, {
      locale: 'ja',
      dateFormat: 'Y-m-d',
      disableMobile: true,

      // 当日からOK
      minDate: 'today'
    });
  }

  initNormalMode();

  if (priorityCheckbox) {
    priorityCheckbox.addEventListener('change', () => {
      const selectedDate = dateInput.value;

      if (priorityCheckbox.checked) {
        initPriorityMode();
      } else {
        initNormalMode();
      }

      if (selectedDate) {
        picker.setDate(selectedDate, false);
      }
    });
  }
});